import moment from "moment";
import * as Utils from "./utils";

const localeFormat = "L";
const isoDateFormat = "YYYY-MM-DD";

export default class DateFormatter {
    static get locale() {
        return moment.locale();
    }

    static toIsoString(localeDate: string | Date, formatter: string = localeFormat): string {
        if (localeDate == null)
            return null;

        const date = (typeof localeDate == "string" && this.isIsoDate(localeDate))
            ? moment(localeDate)
            : moment(localeDate, formatter);

        if (!date.isValid())
            return null;

        const year = date.year();
        const month = Utils.leftPad(1 + date.month());
        const day = Utils.leftPad(date.date());

        return `${year}-${month}-${day}`;
    }

    static toLocaleString(isoDate: string | Date, formatter: string = localeFormat): string {
        if (isoDate == null)
            return null;

        const date = moment(isoDate, [isoDateFormat, formatter]);
        if (date == null)
            return null;

        return date.format(formatter);
    }

    private static isIsoDate(date: string) {
        return RegExp(/(\d{4})-(\d{2})(?:-(\d{0,2})(?:T(\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?)?)?/gm).test(date);
    }
}